import { CLUSTER_INDEX } from "@/lib/guides-cluster-index";

/**
 * Supporting-guide cluster for a hub page.
 *
 * These are the child queries that feed the hub's head term (e.g. "palworld
 * breeding calculator all combos" → /breeding, "palworld tcg pull rates" →
 * /booster-pack). Rendered as real anchors with keyword-matched text so
 * crawlers treat the hub as the centre of a topic cluster instead of a lone
 * page.
 *
 * The links come from the generated CLUSTER_INDEX (slug + title only) rather
 * than the guide data modules — importing those pulled every guide body into
 * each hub page's JS bundle.
 */
export function ClusterLinks({ hub, heading }: { hub: string; heading: string }) {
  const items = CLUSTER_INDEX[hub] ?? [];
  if (!items.length) return null;

  return (
    <nav aria-label={heading} className="glass rounded-2xl p-6 mt-8">
      <h2 className="text-xl font-bold">{heading}</h2>
      <ul className="mt-4 grid gap-2 sm:grid-cols-2">
        {items.map((it) => (
          <li key={it.slug}>
            <a href={`/guides/${it.slug}`} className="text-sm font-semibold text-primary hover:underline">
              {it.title}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
